export const getOffsetValues = (i, conditions, cardsGaps) => {
  let headerHeight;
  let cardGap;

  if (conditions.isMobile) {
    headerHeight = 52;
    cardGap = cardsGaps.mobile;
  } else if (conditions.isTablet) {
    headerHeight = conditions.isMg ? 103 : 88;
    cardGap = cardsGaps.tablet;
  } else if (conditions.isLaptop) {
    headerHeight = conditions.isMg ? 103 : 88;
    cardGap = cardsGaps.laptop;
  } else {
    headerHeight = conditions.isMg ? 103 : 88;
    cardGap = cardsGaps.desktop;
  }

  const topGap = headerHeight + 25;

  return i === 1 ? topGap : topGap + (i - 1) * cardGap;
};
